import type { GetServerSidePropsContext, NextPage } from 'next';
import { useRouter } from 'next/router';
import Container from '../../components/container/container.component';
import Facets from '../../components/facets/facets.component';
import FindsTableComponent from '../../components/finds-table/finds-table.component';
import Pagination from '../../components/pagination/pagination.component';
import { getFinds } from '../../lib/endpoints/getFinds';
import PageTemplate from '../../templates/page.template';
import { FindsListProps } from '../../types/finds-list-props.interface';

interface Props extends FindsListProps { }

const FindsListPage: NextPage<Props> = ({
  options,
  menu,
  prev,
  next,
  facetDistribution,
  hits,
  nbHits,
  initialFacets,
  baseFacets,
}) => {
  const router = useRouter();
  return (
    <PageTemplate
      menu={menu}
      options={options}
      title={'Browse finds'}
      description={options.description}
      isInitiallyDark={true}
    >
      <Container
        css={{ height: 'auto', minHeight: 'calc(100vh - 240px)' }}
        column={true}
      >
        <h1 className="pageHeader">Browse finds</h1>
        {hits.length ? (
          <div className="columnsWrapper">
            <div>
              <Facets
                facets={facetDistribution}
                initialValues={initialFacets}
                baseFacets={baseFacets}
                type="finds"
              />
            </div>
            <div>
              <FindsTableComponent finds={hits} prev={prev[0]} next={next[0]} />
            </div>
            <Pagination router={router} nbHits={nbHits} />
          </div>
        ) : (
          <div className="not-found">No items found.</div>
        )}
      </Container>
    </PageTemplate>
  );
};
export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const {
    facetDistribution,
    hits,
    menu,
    options,
    estimatedTotalHits,
    baseFacets,
    prev,
    next,
  } = await getFinds(Number(ctx.query.page) || 0);
  const initialFacets: { [key: string]: string[] } = {};

  ctx.res.setHeader('Cache-Control', 'public, max-age=300, s-maxage=300');

  for (const facet of Object.keys(facetDistribution)) {
    initialFacets[facet] = [];
  }
  return {
    props: {
      prev: prev ? prev.hits : [],
      next: next.hits,
      facetDistribution,
      hits,
      nbHits: estimatedTotalHits,
      initialFacets,
      baseFacets,
      menu,
      options,
    },
  };
}

export default FindsListPage;
